
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWhatsapp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 38,
  viewBox: "0 0 38 38",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "Whatsapp_f8a78589fdd7278a__b",
  d: "M0 0h16.602v16.425H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 8.189c0 2.648 1.613 4.857 1.613 4.857l-1.01 2.981 3.113-1.004s2.027 1.355 4.561 1.355c4.571 0 8.277-3.667 8.277-8.19C16.554 3.667 12.848 0 8.277 0S0 3.666 0 8.189m10.471 4.554c-.589-.163-2.538-.667-3.808-1.839s-2.3-2.406-2.72-3.316c-.421-.91-.398-1.45-.374-1.705.023-.254.158-1.433.956-1.938 0 0 .266-.167.405-.167h.777s.208.035.303.25.75 1.736.799 1.853c.048.118.176.408-.028.668-.204.26-.63.746-.63.746s-.169.15-.023.39c.146.239.66 1.028 1.333 1.625.673.596 1.497 1.035 1.907 1.168.411.134.501-.044.658-.244.158-.2.648-.813.648-.813s.169-.245.5-.095c.332.15 1.947.924 1.947.924s.197.034.208.25c.01.218.146.867-.44 1.492-.476.51-1.392.796-2.033.796-.145 0-.276-.015-.385-.045",
  id: "Whatsapp_f8a78589fdd7278a__d"
}), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "39.433%",
  y1: "88.596%",
  x2: "60.566%",
  y2: "11.404%",
  id: "Whatsapp_f8a78589fdd7278a__e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#40BA57",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#40BA57",
  offset: "25%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#40BA58",
  offset: "37.5%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#40BB58",
  offset: "43.75%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#41BB58",
  offset: "50%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#42BB59",
  offset: "53.125%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#42BB59",
  offset: "56.25%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#43BB59",
  offset: "59.375%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#44BC5A",
  offset: "60.938%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#44BC5A",
  offset: "62.5%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#45BC5A",
  offset: "64.063%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46BC5B",
  offset: "65.625%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46BD5B",
  offset: "67.188%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#47BD5C",
  offset: "68.75%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#48BD5C",
  offset: "70.313%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#49BD5D",
  offset: "71.094%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#49BD5D",
  offset: "71.875%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4ABE5D",
  offset: "72.656%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4ABE5D",
  offset: "73.438%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4BBE5E",
  offset: "74.219%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4BBE5E",
  offset: "75%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4CBE5E",
  offset: "75.781%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4CBF5F",
  offset: "76.563%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4DBF5F",
  offset: "77.344%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4EBF60",
  offset: "78.125%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4EBF60",
  offset: "78.906%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4FBF60",
  offset: "79.688%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#50C061",
  offset: "80.469%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#51C061",
  offset: "81.25%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#51C062",
  offset: "82.031%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52C162",
  offset: "82.813%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#53C163",
  offset: "83.594%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#54C163",
  offset: "83.984%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#54C164",
  offset: "84.375%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#55C164",
  offset: "84.766%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#55C264",
  offset: "85.156%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#56C264",
  offset: "85.547%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#56C265",
  offset: "85.938%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#57C265",
  offset: "86.328%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#57C265",
  offset: "86.719%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58C266",
  offset: "87.109%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58C366",
  offset: "87.5%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#59C366",
  offset: "87.891%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#59C367",
  offset: "88.281%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5AC367",
  offset: "88.672%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5AC367",
  offset: "89.063%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5BC468",
  offset: "89.453%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5BC468",
  offset: "89.844%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5CC468",
  offset: "90.234%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5DC469",
  offset: "90.625%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5DC469",
  offset: "91.016%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5EC56A",
  offset: "91.406%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5EC56A",
  offset: "91.797%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5FC56A",
  offset: "92.188%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#60C56B",
  offset: "92.578%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#60C56B",
  offset: "92.969%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#61C66C",
  offset: "93.359%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#62C66C",
  offset: "93.75%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#62C66D",
  offset: "94.141%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#63C66D",
  offset: "94.531%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#64C76E",
  offset: "94.922%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#64C76E",
  offset: "95.313%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#65C76E",
  offset: "95.703%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#66C76F",
  offset: "96.094%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#66C76F",
  offset: "96.875%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#66C76F",
  offset: "100%"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-60%",
  y: "-60%",
  width: "220%",
  height: "220%",
  filterUnits: "objectBoundingBox",
  id: "Whatsapp_f8a78589fdd7278a__a"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Whatsapp_f8a78589fdd7278a__a)",
  transform: "translate(9 9)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.146 17.937c-2.533 0-4.561-1.354-4.561-1.354l-3.113 1.004 1.01-2.98S1.87 12.396 1.87 9.747c0-4.522 3.706-8.188 8.277-8.188 4.572 0 8.277 3.666 8.277 8.188 0 4.523-3.705 8.19-8.277 8.19m0-17.938C4.704 0 .293 4.365.293 9.748c0 2.673 1.43 5.061 1.43 5.061L0 20l5.4-1.707s2.003 1.204 4.746 1.204c5.442 0 9.854-4.365 9.854-9.749C20 4.365 15.588 0 10.146 0",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.84 1.558)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "Whatsapp_f8a78589fdd7278a__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Whatsapp_f8a78589fdd7278a__b"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#Whatsapp_f8a78589fdd7278a__c)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(.028 .002)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "Whatsapp_f8a78589fdd7278a__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Whatsapp_f8a78589fdd7278a__d"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#Whatsapp_f8a78589fdd7278a__e)",
  fillRule: "nonzero",
  mask: "url(#Whatsapp_f8a78589fdd7278a__f)",
  d: "M15.445 20.472-4.139 15.28 1.11-4.094l19.584 5.191z"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M15.198 12.06c.01.217.146.867-.44 1.491-.584.626-1.828.915-2.418.752-.589-.163-2.537-.667-3.808-1.84-1.27-1.172-2.3-2.406-2.72-3.315-.421-.91-.398-1.45-.374-1.705.023-.254.158-1.433.956-1.938 0 0 .266-.167.405-.167h.777s.208.035.303.25c.096.214.75 1.736.799 1.853.049.117.176.408-.028.668-.204.26-.63.746-.63.746s-.169.15-.023.39c.146.239.66 1.028 1.333 1.624.673.597 1.497 1.035 1.908 1.17.41.133.5-.045.658-.246.157-.2.647-.812.647-.812s.169-.245.5-.095c.332.15 1.947.924 1.947.924s.197.033.208.25",
  fill: "#FFF",
  fillRule: "nonzero"
}))));

      const __svgRaw = "<svg width=\"38\" height=\"38\" viewBox=\"0 0 38 38\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <defs>\r\n        <path id=\"35098qfl3b\" d=\"M0 0h16.602v16.425H0z\"/>\r\n        <path d=\"M0 8.189c0 2.648 1.613 4.857 1.613 4.857l-1.01 2.981 3.113-1.004s2.027 1.355 4.561 1.355c4.571 0 8.277-3.667 8.277-8.19C16.554 3.667 12.848 0 8.277 0S0 3.666 0 8.189m10.471 4.554c-.589-.163-2.538-.667-3.808-1.839s-2.3-2.406-2.72-3.316c-.421-.91-.398-1.45-.374-1.705.023-.254.158-1.433.956-1.938 0 0 .266-.167.405-.167h.777s.208.035.303.25.75 1.736.799 1.853c.048.118.176.408-.028.668-.204.26-.63.746-.63.746s-.169.15-.023.39c.146.239.66 1.028 1.333 1.625.673.596 1.497 1.035 1.907 1.168.411.134.501-.044.658-.244.158-.2.648-.813.648-.813s.169-.245.5-.095c.332.15 1.947.924 1.947.924s.197.034.208.25c.01.218.146.867-.44 1.492-.476.51-1.392.796-2.033.796-.145 0-.276-.015-.385-.045\" id=\"gjt43aqeid\"/>\r\n        <linearGradient x1=\"39.433%\" y1=\"88.596%\" x2=\"60.566%\" y2=\"11.404%\" id=\"hwj3u9812e\">\r\n            <stop stop-color=\"#40BA57\" offset=\"0%\"/>\r\n            <stop stop-color=\"#40BA57\" offset=\"25%\"/>\r\n            <stop stop-color=\"#40BA58\" offset=\"37.5%\"/>\r\n            <stop stop-color=\"#40BB58\" offset=\"43.75%\"/>\r\n            <stop stop-color=\"#41BB58\" offset=\"50%\"/>\r\n            <stop stop-color=\"#42BB59\" offset=\"53.125%\"/>\r\n            <stop stop-color=\"#42BB59\" offset=\"56.25%\"/>\r\n            <stop stop-color=\"#43BB59\" offset=\"59.375%\"/>\r\n            <stop stop-color=\"#44BC5A\" offset=\"60.938%\"/>\r\n            <stop stop-color=\"#44BC5A\" offset=\"62.5%\"/>\r\n            <stop stop-color=\"#45BC5A\" offset=\"64.063%\"/>\r\n            <stop stop-color=\"#46BC5B\" offset=\"65.625%\"/>\r\n            <stop stop-color=\"#46BD5B\" offset=\"67.188%\"/>\r\n            <stop stop-color=\"#47BD5C\" offset=\"68.75%\"/>\r\n            <stop stop-color=\"#48BD5C\" offset=\"70.313%\"/>\r\n            <stop stop-color=\"#49BD5D\" offset=\"71.094%\"/>\r\n            <stop stop-color=\"#49BD5D\" offset=\"71.875%\"/>\r\n            <stop stop-color=\"#4ABE5D\" offset=\"72.656%\"/>\r\n            <stop stop-color=\"#4ABE5D\" offset=\"73.438%\"/>\r\n            <stop stop-color=\"#4BBE5E\" offset=\"74.219%\"/>\r\n            <stop stop-color=\"#4BBE5E\" offset=\"75%\"/>\r\n            <stop stop-color=\"#4CBE5E\" offset=\"75.781%\"/>\r\n            <stop stop-color=\"#4CBF5F\" offset=\"76.563%\"/>\r\n            <stop stop-color=\"#4DBF5F\" offset=\"77.344%\"/>\r\n            <stop stop-color=\"#4EBF60\" offset=\"78.125%\"/>\r\n            <stop stop-color=\"#4EBF60\" offset=\"78.906%\"/>\r\n            <stop stop-color=\"#4FBF60\" offset=\"79.688%\"/>\r\n            <stop stop-color=\"#50C061\" offset=\"80.469%\"/>\r\n            <stop stop-color=\"#51C061\" offset=\"81.25%\"/>\r\n            <stop stop-color=\"#51C062\" offset=\"82.031%\"/>\r\n            <stop stop-color=\"#52C162\" offset=\"82.813%\"/>\r\n            <stop stop-color=\"#53C163\" offset=\"83.594%\"/>\r\n            <stop stop-color=\"#54C163\" offset=\"83.984%\"/>\r\n            <stop stop-color=\"#54C164\" offset=\"84.375%\"/>\r\n            <stop stop-color=\"#55C164\" offset=\"84.766%\"/>\r\n            <stop stop-color=\"#55C264\" offset=\"85.156%\"/>\r\n            <stop stop-color=\"#56C264\" offset=\"85.547%\"/>\r\n            <stop stop-color=\"#56C265\" offset=\"85.938%\"/>\r\n            <stop stop-color=\"#57C265\" offset=\"86.328%\"/>\r\n            <stop stop-color=\"#57C265\" offset=\"86.719%\"/>\r\n            <stop stop-color=\"#58C266\" offset=\"87.109%\"/>\r\n            <stop stop-color=\"#58C366\" offset=\"87.5%\"/>\r\n            <stop stop-color=\"#59C366\" offset=\"87.891%\"/>\r\n            <stop stop-color=\"#59C367\" offset=\"88.281%\"/>\r\n            <stop stop-color=\"#5AC367\" offset=\"88.672%\"/>\r\n            <stop stop-color=\"#5AC367\" offset=\"89.063%\"/>\r\n            <stop stop-color=\"#5BC468\" offset=\"89.453%\"/>\r\n            <stop stop-color=\"#5BC468\" offset=\"89.844%\"/>\r\n            <stop stop-color=\"#5CC468\" offset=\"90.234%\"/>\r\n            <stop stop-color=\"#5DC469\" offset=\"90.625%\"/>\r\n            <stop stop-color=\"#5DC469\" offset=\"91.016%\"/>\r\n            <stop stop-color=\"#5EC56A\" offset=\"91.406%\"/>\r\n            <stop stop-color=\"#5EC56A\" offset=\"91.797%\"/>\r\n            <stop stop-color=\"#5FC56A\" offset=\"92.188%\"/>\r\n            <stop stop-color=\"#60C56B\" offset=\"92.578%\"/>\r\n            <stop stop-color=\"#60C56B\" offset=\"92.969%\"/>\r\n            <stop stop-color=\"#61C66C\" offset=\"93.359%\"/>\r\n            <stop stop-color=\"#62C66C\" offset=\"93.75%\"/>\r\n            <stop stop-color=\"#62C66D\" offset=\"94.141%\"/>\r\n            <stop stop-color=\"#63C66D\" offset=\"94.531%\"/>\r\n            <stop stop-color=\"#64C76E\" offset=\"94.922%\"/>\r\n            <stop stop-color=\"#64C76E\" offset=\"95.313%\"/>\r\n            <stop stop-color=\"#65C76E\" offset=\"95.703%\"/>\r\n            <stop stop-color=\"#66C76F\" offset=\"96.094%\"/>\r\n            <stop stop-color=\"#66C76F\" offset=\"96.875%\"/>\r\n            <stop stop-color=\"#66C76F\" offset=\"100%\"/>\r\n        </linearGradient>\r\n        <filter x=\"-60%\" y=\"-60%\" width=\"220%\" height=\"220%\" filterUnits=\"objectBoundingBox\" id=\"oexr8rxbwa\">\r\n            <feOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/>\r\n            <feGaussianBlur stdDeviation=\"2\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"/>\r\n            <feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0\" in=\"shadowBlurOuter1\" result=\"shadowMatrixOuter1\"/>\r\n            <feMerge>\r\n                <feMergeNode in=\"shadowMatrixOuter1\"/>\r\n                <feMergeNode in=\"SourceGraphic\"/>\r\n            </feMerge>\r\n        </filter>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g filter=\"url(#oexr8rxbwa)\" transform=\"translate(9 9)\">\r\n            <path d=\"M10.146 17.937c-2.533 0-4.561-1.354-4.561-1.354l-3.113 1.004 1.01-2.98S1.87 12.396 1.87 9.747c0-4.522 3.706-8.188 8.277-8.188 4.572 0 8.277 3.666 8.277 8.188 0 4.523-3.705 8.19-8.277 8.19m0-17.938C4.704 0 .293 4.365.293 9.748c0 2.673 1.43 5.061 1.43 5.061L0 20l5.4-1.707s2.003 1.204 4.746 1.204c5.442 0 9.854-4.365 9.854-9.749C20 4.365 15.588 0 10.146 0\" fill=\"#FFF\" fill-rule=\"nonzero\"/>\r\n            <g transform=\"translate(1.84 1.558)\">\r\n                <mask id=\"il5cyp52ec\" fill=\"#fff\">\r\n                    <use xlink:href=\"#35098qfl3b\"/>\r\n                </mask>\r\n                <g mask=\"url(#il5cyp52ec)\">\r\n                    <g transform=\"translate(.028 .002)\">\r\n                        <mask id=\"cq6d6y03jf\" fill=\"#fff\">\r\n                            <use xlink:href=\"#gjt43aqeid\"/>\r\n                        </mask>\r\n                        <path fill=\"url(#hwj3u9812e)\" fill-rule=\"nonzero\" mask=\"url(#cq6d6y03jf)\" d=\"M15.445 20.472-4.139 15.28 1.11-4.094l19.584 5.191z\"/>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n            <path d=\"M15.198 12.06c.01.217.146.867-.44 1.491-.584.626-1.828.915-2.418.752-.589-.163-2.537-.667-3.808-1.84-1.27-1.172-2.3-2.406-2.72-3.315-.421-.91-.398-1.45-.374-1.705.023-.254.158-1.433.956-1.938 0 0 .266-.167.405-.167h.777s.208.035.303.25c.096.214.75 1.736.799 1.853.049.117.176.408-.028.668-.204.26-.63.746-.63.746s-.169.15-.023.39c.146.239.66 1.028 1.333 1.624.673.597 1.497 1.035 1.908 1.17.41.133.5-.045.658-.246.157-.2.647-.812.647-.812s.169-.245.5-.095c.332.15 1.947.924 1.947.924s.197.033.208.25\" fill=\"#FFF\" fill-rule=\"nonzero\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/Whatsapp.f8a78589fdd7278a5c25ecf4c04c17c7.svg"),
        {
          React: SvgWhatsapp,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      